import { ModalConfirmation, ModalProps, useModal } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

interface DepositInvoiceUnavailableModalProps extends ModalProps {
  onCreateRegularInvoice: () => void
}

export const DepositInvoiceUnavailableModal = ({
  id,
  onCreateRegularInvoice,
}: DepositInvoiceUnavailableModalProps): ReactElement => {
  const { t } = useTranslation()
  const { close } = useModal(id)

  const handleCreateRegularInvoiceClick = useCallback(() => {
    onCreateRegularInvoice()
    close()
  }, [close, onCreateRegularInvoice])

  return (
    <ModalConfirmation
      id={id}
      title={t('quotes.view.deposit_invoice_unavailable_modal.title')}
      message={t('quotes.view.deposit_invoice_unavailable_modal.description')}
      okLabel={t('quotes.view.deposit_invoice_unavailable_modal.create_regular_invoice')}
      cancelLabel={t('return')}
      onOk={handleCreateRegularInvoiceClick}
    />
  )
}
